define("SDB.SDBLocations.QuoteConfirmation.View", [
  "sdb_quote_confirmation.tpl",
  "SCView",
  "SDB.SDBLocations.Model",
], function (sdb_quote_confirmation_tpl, SCViewComponent, SDBLocationModel) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBQuoteConfirmation(options) {
    SCView.call(this);
    this.env = options.container.getComponent("Environment");

    this.options = options;
    this.model = SDBLocationModel.getInstance();
    this.template = sdb_quote_confirmation_tpl;

    this.updateMessage();

    var self = this;
    this.model.on(
      "change:location",
      function () {
        if (self.model.getShoppingExperience() === "online") return;
        self.updateMessage();
        self.render();
      },
      this
    );

    this.model.on(
      "change:shoppingExperience",
      function () {
        if (self.model.getShoppingExperience() !== "online") return;
        self.updateMessage();
        self.render();
      },
      this
    );
  }

  SDBQuoteConfirmation.prototype = Object.create(SCView.prototype);
  SDBQuoteConfirmation.prototype.constructor = SDBQuoteConfirmation;

  SDBQuoteConfirmation.prototype.formatPhoneNumber = function formatPhoneNumber(
    phoneNumber
  ) {
    var regex = /\+1(\d{3})(\d{3})(\d{4})/;
    var match = phoneNumber.match(regex);
    if (match) {
      return {
        formatted: "(" + match[1] + ") " + match[2] + "-" + match[3],
        raw: "+1-" + match[1] + "-" + match[2] + "-" + match[3],
      };
    }
  };

  SDBQuoteConfirmation.prototype.updateMessage = function updateMessage() {
    if (
      this.model.getShoppingExperience() === "online" ||
      !this.model.getSelectedLocation()
    ) {
      this.disclaimer = this.env.getConfig("quote.disclaimer");
      return;
    }
    var subsidiaryInformation = this.model.getSelectedLocation();
    var salesrepEmail = subsidiaryInformation.email;
    var salesrepName = subsidiaryInformation.name;
    if (!subsidiaryInformation.phone) {
      this.disclaimer =
        'For immediate assistance send an email to <a href="mailto:' +
        salesrepEmail +
        '">' +
        salesrepEmail +
        "</a>";
      return;
    }
    var phoneParts = this.formatPhoneNumber(subsidiaryInformation.phone);
    this.disclaimer =
      "For immediate assistance contact <strong>" +
      salesrepName +
      " Contact Center</strong> at <strong>" +
      phoneParts.formatted +
      '</strong> or send an email to <a href="mailto:' +
      salesrepEmail +
      '">${salesrepEmail}</a>';
  };

  SDBQuoteConfirmation.prototype.getContext = function () {
    return {
      disclaimer: this.disclaimer,
    };
  };

  return SDBQuoteConfirmation;
});
